<template>
    <!-- BEGIN Customers Table-->
    <div class="container-fluid customers-table">
        <div class="search-results m-t-20">
            <div class="row">
                <div class="col-md-12">
                    <div class="panel panel-transparent">
                        <div class="panel-body">
                            <div class="table-responsive" v-if="customers.hasOwnProperty('data') && customers.data.length > 0">
                                <table class="table table-hover table-condensed table-detailed search-table"
                                       id="detailedTable">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Entreprise
                                                <template v-if="canSort(sortParams, 'byCorporationName')">
                                                    <a v-if="sortParams.byCorporationName.colSort"
                                                       @click="notifiyParentOnSortParamChange"
                                                       title="Trier par order alphabétique A -> Z">
                                                        <i class="fa fa-sort-alpha-asc"></i>
                                                    </a>
                                                    <a v-else
                                                       @click="notifiyParentOnSortParamChange"
                                                       title="Trier par order alphabétique Z -> A">
                                                        <i class="fa fa-sort-alpha-desc"></i>
                                                    </a>
                                                </template>
                                            </th>
                                            <th>RP</th>
                                            <th>Contrats
                                            </th>
                                            <th>Options</th>
                                            <!-- <th>Solde</th> -->
                                            <th>Détails</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(customer, index) in customers.data">
                                            <item @click="onItemClick(index)"
                                                  :customer="customer"
                                                  :show-details="idxItemDetails === index"
                                                  :has-details="hasDetails(customer)"
                                                  :key="'customerlist-item-'+index">
                                            </item>
                                            <item-details v-if="idxItemDetails === index"
                                                          :customer="customer"
                                                          :key="'customerlist-item-details-'+index">
                                            </item-details>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else>
                                <hr>
                                
                                <div class="alert alert-info">
                                    <i class="fa fa-info-circle"></i> Aucune correspondance n'a été trouvée
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END Customers Table !-->
</template>

<style lang="scss" scoped>
    .customers-table {
        padding: 0;
    }
    
    .panel-body {
        min-width: 600px;
        padding: 0;
    }
    
    .search-table {
        th {
            width: auto;
            &:first-child {
                width: 20px;
            }
            &:last-child {
                width: 113px;
            }
        }
    }
</style>

<script type="text/babel">
    import Item from './Item'
    import ItemDetails from './ItemDetails'

    export default {
        props: ['customers', 'searchFilters', 'sortParams'],

        components: {
            Item,
            ItemDetails
        },

        data () {
            return {
                idxItemDetails: null,
                sortOrders: {
                    entreprise: true,
                    rp: null,
                },
            }
        },

        methods: {

            canSort (params, byField) {
                if (_.isNil(params))
                    return false
                return params.hasOwnProperty(byField)
                //&& params[byField].colSort
            },

            onItemClick (idx) {
                this.idxItemDetails = (this.idxItemDetails !== idx) ? idx : null
            },

            hasDetails (customer) {
                return _.filter(
                    customer.contracts,
                    contract => contract.type === "domiciliation_contract"
                ).length
            },

            changeSort (orderFields) {
                if (orderFields === "name") {
                    this.$emit('th-click', {
                        orderBy: orderFields,
                        sortedBy: this.sortParams.byCorporationName.colSort ? "desc" : "asc"
                    })
                }
                else if (orderFields === "created_at") {
                    this.$emit('th-click', {
                        orderBy: orderFields,
                        sortedBy: this.sortParams.byCreationDate.colSort ? "desc" : "asc"
                    })
                }
                else if (orderFields === "main_representative.last_name") {
                    this.$emit('th-click', {
                        orderBy: orderFields,
                        sortedBy: this.sortParams.byMainRepresentative.colSort ? "desc" : "asc"
                    })
                }
            },

            notifiyParentOnSortParamChange () {
                this.$emit('pre-sort-click', { colName: "name", newColSort: !this.sortParams.byCorporationName.colSort })
                this.$nextTick(() => this.changeSort("name"))
            },
        }
    }
</script>



// WEBPACK FOOTER //
// client/components/CustomersList/CustomersTable.vue